import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 1000000;
            return true;
        })
        .required("Angabe ist erforderlich"),
    periodOfCancellation: checkRequiredText(settings),
    becomingAwareThrough: checkRequiredText(settings),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formPeriodOfCancellation">
                <Form.Label>Kündigungsfrist*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Kündigungsfrist eingeben"
                    type="text"
                    name="periodOfCancellation"
                    value={values.periodOfCancellation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.periodOfCancellation && !errors.periodOfCancellation}
                    isInvalid={touched.periodOfCancellation && errors.periodOfCancellation}
                    maxLength={settings.textInputLimit}
            />
                <Form.Control.Feedback type="invalid">
                    {errors.periodOfCancellation}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Bruttojahresgehaltswunsch*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Bruttojahresgehaltswunsch eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={6}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBecomingAwareThrough">
                <Form.Label>Wie sind Sie auf uns aufmerksam geworden?*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Bitte eingeben, wie Sie auf uns aufmerksam geworden sind"
                    type="text"
                    name="becomingAwareThrough"
                    value={values.becomingAwareThrough}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                    isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                    maxLength={settings.textInputLimit}
            />
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThrough}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};